<template>
  <div>
    <b-table
      selectable
      select-mode="single"
      selectedVariant="secondary"
      hover
      show-empty
      :items="objItems"
      :fields="!viewFind?objFilds:objFildsFind"
      @row-selected="gridSelected"
      :tbody-tr-class="rowClass"
    >
      <!-- TEMPLATE EMPTY -->
      <template slot="empty">
        <p>NO RECORD FOUND</p>
      </template>

      <!-- TEMPLATE NUM-RECORD -->
      <template
        slot="num-record"
        slot-scope="data"
      >{{ data.index + 1 * ((numPage * rowLimit) - rowLimit) + 1 }}</template>

      <!-- TEMPLATE ACTION -->
      <template v-slot:cell(actions)="row" v-if="!viewFind">
        <b-button size="sm" pill variant="outline-secondary" @click="rowSelected(row.item)">
          <i class="fas fa-pen"></i>
        </b-button>
      </template>

      <!-- TEMPLATE ROW SELECTED -->
      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span>
            <i class="fa fa-check text-primary"></i>
          </span>
        </template>
      </template>
    </b-table>

    <!-- PAGINATION -->
    <b-pagination
      size="sm"
      pills
      v-model="numPage"
      :total-rows="rowCount"
      :per-page="rowLimit"
      align="center"
      class="btn-default"
    />
  </div>
</template>
<script>
/* ========================================= CUSTOM EVENTS =========================================

1) selectedGridSecurityRole: Utilizado no método gridSelected().
2) selectedSecurityRole: Utilizado no método rowSelected().

=================================================================================================== */

/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - PAGE */
export default {
  name: "SecurityRoleGrid",
  props: {
    resetRowSelected: Boolean
  },
  computed: {
    viewFind() {
      return this.$store.state.layout.viewFind;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objFilter() {
      return this.$store.state.objFilter;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    applyFilter() {
      return this.$store.state.applyFilter;
    },
    resetFilter() {
      return this.$store.state.resetFilter;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "security-ds/api/internal/security-role",
      primary_key: "security_role_id",
      numPage: 1,
      rowLimit: 0,
      rowCount: 0,

      /* Objects Page */
      nameObjData: "security_role_data",
      objItems: [],
      objFilds: [
        { key: "num-record", label: "", class: "cell-num-record" },
        { key: "actions", label: "", class: "cell-action" },
        {
          key: "security_role_id",
          label: "Security Role",
          sortable: true
        },
        {
          key: "security_role_data.role_description",
          label: "Description",
          sortable: true
        },
        {
          key: "security_role_data.init_dt",
          label: "Init. Dt",
          sortable: true
        },
        { key: "security_role_data.end_dt", label: "End Dt", sortable: true }
      ],
      objFildsFind: [
        { key: "num-record", label: "", class: "cell-num-record" },
        {
          key: "security_role_id",
          label: "Security Role",
          sortable: true
        },
        {
          key: "security_role_data.role_description",
          label: "Role Description",
          sortable: true
        },
        { key: "selected", label: "" }
      ]
    };
  },

  /* METHODS */
  methods: {
    init() {
      this.list();
    },

    list() {
      this.$store.commit("setShowLoading", true);
      this.objItems = [];
      let paramFilter = {};

      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objFilter).length > 0) {
          paramFilter = { ...this.objFilter };
        }

        if (Object.entries(paramFilter).length === 0) {
          axios
            .post(`${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all`)
            .then(res => {
              if (res.data[0][`${this.primary_key}`] != null)
                this.objItems = res.data;
              this.$store.commit("setShowLoading", false);
            });
        } else {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-filter`;
          axios.post(url, paramFilter).then(res => {
            if (res.data[0][`${this.primary_key}`] != null)
              this.objItems = res.data;
            this.$store.commit("setObjFilter", {});
            this.$store.commit("setShowLoading", false);
          });
        }
      }
    },

    rowSelected(item) {
      this.$emit("selectedSecurityRole", item);
    },

    gridSelected(items) {
      if (this.viewFind === false) {
        if (items[0]) {
          this.$store.commit("setObjSelected", items[0]);
          this.$emit("securityRoleSelected", items[0].role_name);
        }
      } else {
        if (items[0]) {
          this.$emit("selectedGridSecurityRole", items[0]);
        }
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.security_role_data.end_dt !== null) return "wt-row-inactive";
    }
  },

  /* WATCH */
  watch: {
    selectedObjItem() {
      if (Object.entries(this.selectedObjItem).length > 0) {
        this.$emit("selectedSecurityRole", this.selectedObjItem);
      }
    },
    applyFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.applyFilter === true) {
          this.list();
        }
      }
    },
    resetFilter() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.resetFilter === true) {
          this.list();
        }
      }
    },
    urlServicesStore() {
      if (this.urlServicesStore === this.urlServices) {
        this.$store.commit("setObjFilter", {});
        this.list();
      }
    },
    resetRowSelected() {
      if (this.resetRowSelected === true) {
        this.init();
      }
    }
  },

  /* LIFE CICLE */
  mounted() {
    this.init();
  }
};
</script>